const Enter = resolve => require.ensure([], () => resolve(require('@/views/enter/enter.vue')), 'Enter')
// const Company = resolve => require.ensure([], () => resolve(require('./node_modules/@/views/enter/company/company.vue')), 'Company')
// const Circuit = resolve => require.ensure([], () => resolve(require('./node_modules/@/views/enter/circuit/circuit.vue')), 'Circuit')
export default [
    {
        path: '/enter',
        // redirect: { name: 'enter-company' },
        component: Enter,
        name: 'enter',
        meta: {
            title: '入驻',
            icons: 'fa fa-enter',
            //对父路由进行了校验子路由可以不用校验
            requireAuth: true
        },
        children: [
            // {
            //     path: '/enter/company',
            //     redirect: {
            //         name: 'enter-company-create'
            //     },
            //     name: 'enter-company',
            //     component: Company,
            //     meta: {
            //         icons: 'fa fa-company'
            //     },
            //     children: [
            //         {
            //             path: '/enter/company/create',
            //             name: 'enter-company-create',
            //             component: CompanyCreate,
            //             meta: {
            //                 title: '填写公司信息',
            //                 icons: 'fa fa-create'
            //             },
            //         },
            //         {
            //             path: '/enter/company/edit/:id',
            //             name: 'enter-company-edit',
            //             component: CompanyEdit,
            //             meta: {
            //                 title: '修改公司信息',
            //                 icons: 'fa fa-edit'
            //             },
            //         }
            //     ]
            // },
            // {
            //     path: '/enter/circuit',
            //     redirect: {
            //         name: 'enter-circuit-create'
            //     },
            //     name: 'enter-circuit',
            //     component: Circuit,
            //     children: [
            //         {
            //             path: '/enter/circuit/create',
            //             name: 'enter-circuit-create',
            //             component: CircuitCreate,
            //             meta: {
            //                 title: '填写线路',
            //                 icons: 'fa fa-create'
            //             }
            //         },
            //         {
            //             path: '/enter/circuit/edit/:id',
            //             name: 'enter-circuit-edit',
            //             component: CircuitEdit,
            //             meta: {
            //                 title: '修改线路',
            //                 icons: 'fa fa-edit'
            //             }
            //         }
            //     ]
            // }
        ]
    }

]